import { PLATFORMS, type PlatformId } from '@ai-media/shared';
import { useTranslation } from 'react-i18next';

export default function PlatformChip({ platform }: { platform: PlatformId }) {
  const { t } = useTranslation();
  const def = PLATFORMS[platform];
  const label = t(`platforms.${platform}`);
  return (
    <span className="platform-chip" style={{ color: def?.color ?? 'var(--ion-color-medium)' }}>
      {label === `platforms.${platform}` ? platform : label}
    </span>
  );
}
